import omit from 'lodash/omit';
import { COMPONENT_HASH } from '../constants/contentPageComponents';

export const renderComponent = (component, key) => {
  const props = omit(component, 'type');
  const Component = COMPONENT_HASH[component.type];
  if (Component) {
    return <Component key={key} {...props} />;
  }
  return null;
};
